<!--
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-07 16:12:34
 * @LastEditTime: 2020-04-26 16:08:22
 * @Description: 
 -->

<template>
    <div class="head-page">
        <h1 id="head">
            <img :src="img" />国美（天津）水技术工程有限公司
            <span
                >USF(Tianjin) Water Technologies and Engineering Co.,Ltd.</span
            >
        </h1>
        <em class="icon" id="icon" @click="Open"></em>
        <span class="logout" @click="handleCommand">Exit</span>
    </div>
</template>
<script>
import img from "@/assets/front/logo1.png";
import { deleteToken } from "@/api/main/api-user";
import { putHost } from "@/api/main/api-host";
import { backend } from "@/router";
var screenWidth;
export default {
    name: "PublicHead",
    data() {
        return {
            img,
            screenWidth: document.body.clientWidth,
        };
    },
    methods: {
        Open: function () {
            document.getElementById("leftMenu").setAttribute("class", "show");
        },
        handleCommand() {
            // 注销token
            this.$confirm("是否确认退出系统?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                lockScroll: false,
            })
                .then(() => {
                    deleteToken().then((res) => {
                        if (res.code === 0) {
                            this.$store.dispatch("logoutAction");
                            this.$notify.success({
                                title: "成功",
                                message: "成功退出系统",
                                duration: 500,
                                onClose: () => {
                                    this.$router.replace("/login");
                                },
                            });
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: res.msg,
                            });
                        }
                    });
                })
                .catch(() => {});
        },
    },
    watch: {
        $route: {
            handler: function () {
                window.onresize();
                if (window.screenWidth < 1024) {
                    document
                        .getElementById("leftMenu")
                        .setAttribute("class", "hide");
                }
            },
        },
    },
    mounted() {
        const that = this;
        window.onresize = () => {
            return (() => {
                window.screenWidth = document.body.clientWidth;
                that.screenWidth = window.screenWidth;
            })();
        };
    },
};
</script>
<style lang="less" scoped>
* {
    margin: 0;
    padding: 0;
    list-style: none;
}
/deep/html,
body {
    overflow: unset;
}
.head-page {
    width: 100%;
    height: 80px;
    background-color: #0a2481;
    text-align: left;
    h1 {
        margin: 0px 0px 0px 5%;
        line-height: 80px;
        font-size: 26px;
        font-weight: normal;
        color: #fff;
        img {
            vertical-align: middle;
            margin: 0px 12px 0px 0px;
        }
    }
    .logout {
        float: right;
        color: #fff;
        font-size: 16px;
        position: absolute;
        top: 24px;
        right: 4vw;
        cursor: pointer;
        em {
            font-style: normal;
            cursor: pointer;
        }
    }
}

@media (max-width: 1024px) {
    .head-page {
        width: 100%;
        height: 60px;
        text-align: center;
        position: relative;
        h1 {
            margin: 0px;
            line-height: 60px;
            font-size: 15px;
            width: 87%;
            margin-left: 2.5%;
            text-align: left;
            img {
                margin: -2px 6px 0px 0px;
                max-width: 55px;
            }
        }
        .logout {
            font-size: 14px;
            top: 20px;
            right: 35px;
        }
        .icon {
            width: 18px;
            height: 16px;
            background: url(../../../assets/front/icon-open.png) center center
                no-repeat;
            display: inline-block;
            position: absolute;
            top: 50%;
            margin-top: -8px;
            right: 2.5%;
            background-size: cover;
            &:hover {
                .left-menu {
                    display: block;
                }
            }
        }
    }
}

@media (max-width: 340px) {
    .head-page {
        h1 {
            font-size: 14px;
            img {
                max-width: 50px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/front/components/head.vue